import { AppLayout } from "@/ui/layouts/AppLayout"
import { PageTitle } from "@/ui/components/ui/page-title"
import { Button } from "@/ui/components"
import { ContactIcon } from "@/ui/components/icons"

/**
 * Contact page - accessible without authentication
 *
 * Displays contact information with an email button that opens
 * the user's default email client.
 */
export default function ContactPage() {
  const contactEmail =
    import.meta.env.VITE_CONTACT_EMAIL || "contact@anyw3ar.com"

  const handleSendEmail = () => {
    window.location.href = `mailto:${contactEmail}`
  }

  return (
    <AppLayout>
      <PageTitle>Contact</PageTitle>

      {/* Team photo with aspect ratio from Figma (311/144) - responsive height */}
      <div
        className="w-full aspect-[311/144] rounded-[0.3125rem] mb-8 bg-gray-100"
        style={{
          backgroundImage: `url(/images/contact-photo-optimized.jpg)`,
          backgroundPosition: "0px 0px",
          backgroundSize: "100% 143.981%",
          backgroundRepeat: "no-repeat",
        }}
        role="img"
        aria-label="ANYW3AR Team"
      />

      {/* Description text */}
      <p className="text-gray-700 text-[0.9375rem] font-montserrat leading-[1.25rem] mb-8">
        Contact us by email
      </p>

      {/* Send Email button */}
      <Button
        variant="primary-dark"
        size="primary-dark"
        leftIcon={<ContactIcon size={12} className="text-gray-100" />}
        onClick={handleSendEmail}
        className="w-full"
      >
        Send email
      </Button>
    </AppLayout>
  )
}
